import AppPaths from '@globals/paths'
import { colors } from '@globals/themes/defaultTheme'
import { Announcement, Award, Recognition } from '@kudos/http-client'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material/styles'
import { T } from '@transifex/react'
import QRCode from 'react-qr-code'
import { TvContent } from '.'

const QR_CODE_SIZE = '8vh'
const containerStyle: SxProps = {
  float: 'right',
  alignItems: 'center',
  paddingBottom: -100,
}

const getPath = (tvContent: TvContent) => {
  switch (tvContent.__entity_type__) {
    case 'recognition':
      return AppPaths.tenant.viewRecognition((tvContent as Recognition).id)
    case 'award':
      return AppPaths.tenant.viewAward((tvContent as Award).id)
    case 'announcement':
      return AppPaths.tenant.admin.announcements((tvContent as Announcement).id)
    case 'calendarEvent':
      return AppPaths.tenant.celebrate()
  }
}

type ViewPostQRCodeProps = {
  tvContent: TvContent
}
const ViewPostQRCode: React.FC<ViewPostQRCodeProps> = ({ tvContent }) => {
  const path = getPath(tvContent)
  return (
    path && (
      <Stack sx={containerStyle} direction="row-reverse" spacing={1}>
        <Card sx={{ width: QR_CODE_SIZE, height: QR_CODE_SIZE }}>
          <QRCode
            size={256}
            style={{ height: QR_CODE_SIZE, width: QR_CODE_SIZE, padding: '6px 8px 8px 6px' }}
            value={`${window.location.origin}${path}`}
          />
        </Card>
        <Typography variant="subtitle1" sx={{ color: colors.white, mt: 0 }}>
          <T _str="View post" />
        </Typography>
      </Stack>
    )
  )
}

export default ViewPostQRCode
